import styles from '../index.module.scss';

interface iSectionProps {
    title: string,
    children: React.ReactNode
}

const Section = ({ title, children }: iSectionProps) => {
    return (
        <div className="section">
            <h2 className="section__title">{title}</h2>
            <div className="section__content">{children}</div>
        </div>
    );
}


export default Section